import { api, bus } from '@brskl/core';

class SupportAPI {
  constructor() {
    Object.getOwnPropertyNames(this).forEach((fnName) => {
      const fn = this[fnName];

      this[fnName] = async (...props) => {
        const { errorOptions = {} } =
          props.find((p) => typeof p === 'object' && p && !(p instanceof Array)) || {};

        return fn(...props)
          .then((r) => r)
          .catch((error) => {
            bus.emit('core$notifications/add', { error, ...errorOptions });
            return Promise.reject(error);
          });
      };
    });
  }

  sendMessage = (opts = {}) => {
    const { text, chat_id } = opts;
    return api.endpoints.business.support.post('chat/message/send', { text, chat_id });
  };

  getMessages = (opts = {}) => {
    const { page, limit, chat_id } = opts;
    return api.endpoints.business.support.get('chat/message/get-list', { page, limit, chat_id });
  };

  setAsRead = (opts = {}) => {
    const { id } = opts;
    return api.endpoints.business.support.post('chat/message/set-as-read', { id });
  };

  downloadFile = (opts = {}) => {
    const { id } = opts;
    const { access_token: token } = api.tokens.getTokens();
    const path = 'chat/message/file/download';

    return api.endpoints.business.support.get({ path, params: { id, token }, options: { linkOnly: true } });
  };

  uploadFile = (opts = {}) => {
    const { chat_id, file, text = '' } = opts;

    return api.endpoints.business.support.post({
      path: 'chat/message/file/upload',
      params: {
        chat_id,
        file,
        text,
      },
    });
  };

  updateMessage = (opts = {}) => {
    const { id, text } = opts;
    const path = 'chat/message/edit'
    return api.endpoints.business.support.post({ path, params: { message_id: id, text } });
  };

  deleteMessage = (opts = {}) => {
    const { id } = opts;
    const path = 'chat/message/delete';
    return api.endpoints.business.support.post({ path, params: { message_id: id } });
  };

  replyToMessage = (opts = {}) => {
    const { text, reply_to } = opts;
    const path = 'chat/message/send'
    return api.endpoints.business.support.post({ path, params: { text, reply_to } });
  };
}

export const supportAPI = new SupportAPI();
